import {benefitStatus} from '#types/benefits.ts';
import {
  ShoppingCart,
  Car,
  ShoppingBasket,
  Thermometer,
  DollarSign,
  Lamp,
  Tag
} from 'lucide-react';

export const categoriesTypesMap = {
  // level 1
  groceries: {
    id: 1,
    titleId: 'Categories.groceries',
    icon: ShoppingCart
  },
  transportation: {
    id: 2,
    titleId: 'Categories.transportation',
    icon: Car
  },
  shopping: {
    id: 3,
    titleId: 'Categories.shopping',
    icon: ShoppingBasket
  },
  health: {
    id: 4,
    titleId: 'Categories.health',
    icon: Thermometer
  },
  banking: {
    id: 7,
    titleId: 'Categories.banking',
    icon: DollarSign
  },
  home: {
    id: 10148,
    icon: Lamp,
    titleId: 'Categories.home'
  },
  subscriptions: {
    id: 10149,
    icon: Tag,
    titleId: 'Categories.subscriptions'
  },

  // level 2
  grocery_stores: {
    id: 10,
    titleId: 'Categories.grocery_stores',
    icon: null
  },
  restaurants: {
    id: 11,
    titleId: 'Categories.restaurants',
    icon: null
  },
  public_transport: {
    id: 12,
    titleId: 'Categories.public_transport',
    icon: null
  },
  car_services: {
    id: 13,
    titleId: 'Categories.car_services',
    icon: null
  },
  clothing_stores: {
    id: 14,
    titleId: 'Categories.clothing_stores',
    icon: null
  },
  electronics: {
    id: 15,
    titleId: 'Categories.electronics',
    icon: null
  },
  fitness_centers: {
    id: 16,
    titleId: 'Categories.fitness_centers',
    icon: null
  },
  medical_services: {
    id: 17,
    titleId: 'Categories.medical_services',
    icon: null
  },
  banks: {
    id: 18,
    titleId: 'Categories.banks',
    icon: null
  },
  insurance_providers: {
    id: 19,
    titleId: 'Categories.insurance_providers',
    icon: null
  },
  optical_services: {
    id: 40,
    titleId: 'Categories.optical_services',
    icon: null
  },
  home_delivery: {
    id: 41,
    titleId: 'Categories.home_delivery',
    icon: null
  },

  // level 3
  food_markets: {
    id: 20,
    titleId: 'Categories.food_markets',
    icon: null
  },
  supermarkets: {
    id: 21,
    titleId: 'Categories.supermarkets',
    icon: null
  },
  fast_food: {
    id: 22,
    titleId: 'Categories.fast_food',
    icon: null
  },
  dining_places: {
    id: 10001,
    icon: null,
    titleId: 'Categories.dining_places'
  },
  casual_dining: {
    id: 10002,
    icon: null,
    titleId: 'Categories.casual_dining'
  },
  family_restaurants: {
    id: 10003,
    icon: null,
    titleId: 'Categories.family_restaurants'
  },
  ethnic_restaurants: {
    id: 10004,
    icon: null,
    titleId: 'Categories.ethnic_restaurants'
  },
  buffet_restaurants: {
    id: 10005,
    icon: null,
    titleId: 'Categories.buffet_restaurants'
  },
  popup_restaurants: {
    id: 10006,
    icon: null,
    titleId: 'Categories.popup_restaurants'
  },
  fast_food_chains: {
    id: 10007,
    icon: null,
    titleId: 'Categories.fast_food_chains'
  },
  burger_joints: {
    id: 10008,
    icon: null,
    titleId: 'Categories.burger_joints'
  },
  pizza_places: {
    id: 10009,
    icon: null,
    titleId: 'Categories.pizza_places'
  },

  group_classes: {
    id: 10010,
    icon: null,
    titleId: 'Categories.group_classes'
  },
  personal_training: {
    id: 10011,
    icon: null,
    titleId: 'Categories.personal_training'
  },
  yoga_pilates: {
    id: 10012,
    icon: null,
    titleId: 'Categories.yoga_pilates'
  },
  martial_arts: {
    id: 10013,
    icon: null,
    titleId: 'Categories.martial_arts'
  },
  swimming_pools: {
    id: 10014,
    icon: null,
    titleId: 'Categories.swimming_pools'
  },

  motorcycle_insurance: {
    id: 10015,
    icon: null,
    titleId: 'Categories.motorcycle_insurance'
  },
  caravan_rv_insurance: {
    id: 10016,
    icon: null,
    titleId: 'Categories.caravan_rv_insurance'
  },
  travel_insurance: {
    id: 10017,
    icon: null,
    titleId: 'Categories.travel_insurance'
  },
  cafes_bakeries: {id: 10018, icon: null, titleId: 'Categories.cafes_bakeries'},
  bars_nightlife: {id: 10019, icon: null, titleId: 'Categories.bars_nightlife'},
  public_transportation: {
    id: 10020,
    icon: null,
    titleId: 'Categories.public_transportation'
  },
  air_travel: {id: 10021, icon: null, titleId: 'Categories.air_travel'},
  accommodation: {id: 10022, icon: null, titleId: 'Categories.accommodation'},
  travel_experiences: {
    id: 10023,
    icon: null,
    titleId: 'Categories.travel_experiences'
  },
  fashion_accessories: {
    id: 10024,
    icon: null,
    titleId: 'Categories.fashion_accessories'
  },
  sports_leisure: {id: 10025, icon: null, titleId: 'Categories.sports_leisure'},
  home_interior: {id: 10027, icon: null, titleId: 'Categories.home_interior'},
  exercise_fitness: {
    id: 10028,
    icon: null,
    titleId: 'Categories.exercise_fitness'
  },
  treatment_therapy: {
    id: 10029,
    icon: null,
    titleId: 'Categories.treatment_therapy'
  },
  beauty_wellness: {
    id: 10030,
    icon: null,
    titleId: 'Categories.beauty_wellness'
  },
  health_products: {
    id: 10031,
    icon: null,
    titleId: 'Categories.health_products'
  },
  banking_services: {
    id: 10032,
    icon: null,
    titleId: 'Categories.banking_services'
  },
  insurance: {id: 10033, icon: null, titleId: 'Categories.insurance'},
  crafts_renovation: {
    id: 10034,
    icon: null,
    titleId: 'Categories.crafts_renovation'
  },
  electrician_plumbing: {
    id: 10035,
    icon: null,
    titleId: 'Categories.electrician_plumbing'
  },
  cleaning_maintenance: {
    id: 10036,
    icon: null,
    titleId: 'Categories.cleaning_maintenance'
  },
  moving_logistics: {
    id: 10037,
    icon: null,
    titleId: 'Categories.moving_logistics'
  },
  car_mobility: {id: 10038, icon: null, titleId: 'Categories.car_mobility'},
  security_alarm: {id: 10039, icon: null, titleId: 'Categories.security_alarm'},
  professional_services: {
    id: 10040,
    icon: null,
    titleId: 'Categories.professional_services'
  },
  convenience_stores: {
    id: 10043,
    icon: null,
    titleId: 'Categories.convenience_stores'
  },
  specialty_stores: {
    id: 10044,
    icon: null,
    titleId: 'Categories.specialty_stores'
  },
  organic_stores: {id: 10045, icon: null, titleId: 'Categories.organic_stores'},
  international_food_stores: {
    id: 10046,
    icon: null,
    titleId: 'Categories.international_food_stores'
  },
  delicatessen: {id: 10047, icon: null, titleId: 'Categories.delicatessen'},
  health_food_stores: {
    id: 10048,
    icon: null,
    titleId: 'Categories.health_food_stores'
  },
  food_trucks: {id: 10049, icon: null, titleId: 'Categories.food_trucks'},
  take_away: {id: 10050, icon: null, titleId: 'Categories.take_away'},
  coffee_shops: {id: 10051, icon: null, titleId: 'Categories.coffee_shops'},
  patisseries: {id: 10052, icon: null, titleId: 'Categories.patisseries'},
  bakeries: {id: 10053, icon: null, titleId: 'Categories.bakeries'},
  juice_smoothie_bars: {
    id: 10054,
    icon: null,
    titleId: 'Categories.juice_smoothie_bars'
  },
  cocktail_bars: {id: 10055, icon: null, titleId: 'Categories.cocktail_bars'},
  wine_bars: {id: 10056, icon: null, titleId: 'Categories.wine_bars'},
  pubs: {id: 10057, icon: null, titleId: 'Categories.pubs'},
  sports_bars: {id: 10058, icon: null, titleId: 'Categories.sports_bars'},
  bus: {id: 10059, icon: null, titleId: 'Categories.bus'},
  train: {id: 10060, icon: null, titleId: 'Categories.train'},
  tram_subway: {id: 10061, icon: null, titleId: 'Categories.tram_subway'},
  ferry: {id: 10062, icon: null, titleId: 'Categories.ferry'},
  city_bikes: {id: 10063, icon: null, titleId: 'Categories.city_bikes'},
  sharing_services: {
    id: 10064,
    icon: null,
    titleId: 'Categories.sharing_services'
  },
  domestic_flights: {
    id: 10065,
    icon: null,
    titleId: 'Categories.domestic_flights'
  },
  international_flights: {
    id: 10066,
    icon: null,
    titleId: 'Categories.international_flights'
  },
  charter_flights: {
    id: 10067,
    icon: null,
    titleId: 'Categories.charter_flights'
  },
  lounge_access: {id: 10068, icon: null, titleId: 'Categories.lounge_access'},
  airport_services: {
    id: 10069,
    icon: null,
    titleId: 'Categories.airport_services'
  },
  hotels: {id: 10070, icon: null, titleId: 'Categories.hotels'},
  apartments: {id: 10071, icon: null, titleId: 'Categories.apartments'},
  cabins: {id: 10072, icon: null, titleId: 'Categories.cabins'},
  camping: {id: 10073, icon: null, titleId: 'Categories.camping'},
  bed_breakfast: {id: 10074, icon: null, titleId: 'Categories.bed_breakfast'},
  resorts: {id: 10075, icon: null, titleId: 'Categories.resorts'},
  package_holidays: {
    id: 10076,
    icon: null,
    titleId: 'Categories.package_holidays'
  },
  cruises: {id: 10077, icon: null, titleId: 'Categories.cruises'},
  activity_holidays: {
    id: 10078,
    icon: null,
    titleId: 'Categories.activity_holidays'
  },
  city_breaks: {id: 10079, icon: null, titleId: 'Categories.city_breaks'},
  round_trips: {id: 10080, icon: null, titleId: 'Categories.round_trips'},
  guided_tours: {id: 10081, icon: null, titleId: 'Categories.guided_tours'},
  clothing: {id: 10082, icon: null, titleId: 'Categories.clothing'},
  shoes: {id: 10083, icon: null, titleId: 'Categories.shoes'},
  bags: {id: 10084, icon: null, titleId: 'Categories.bags'},
  jewelry: {id: 10085, icon: null, titleId: 'Categories.jewelry'},
  watches: {id: 10086, icon: null, titleId: 'Categories.watches'},
  accessories: {id: 10087, icon: null, titleId: 'Categories.accessories'},
  sports_equipment: {
    id: 10088,
    icon: null,
    titleId: 'Categories.sports_equipment'
  },
  workout_clothes: {
    id: 10089,
    icon: null,
    titleId: 'Categories.workout_clothes'
  },
  training_shoes: {id: 10090, icon: null, titleId: 'Categories.training_shoes'},
  outdoor_equipment: {
    id: 10091,
    icon: null,
    titleId: 'Categories.outdoor_equipment'
  },
  bicycles: {id: 10092, icon: null, titleId: 'Categories.bicycles'},
  ski_equipment: {id: 10093, icon: null, titleId: 'Categories.ski_equipment'},
  skates: {id: 10094, icon: null, titleId: 'Categories.skates'},
  water_sports_equipment: {
    id: 10095,
    icon: null,
    titleId: 'Categories.water_sports_equipment'
  },
  mobile_phones: {id: 10096, icon: null, titleId: 'Categories.mobile_phones'},
  computers: {id: 10097, icon: null, titleId: 'Categories.computers'},
  tv_audio: {id: 10098, icon: null, titleId: 'Categories.tv_audio'},
  gaming: {id: 10099, icon: null, titleId: 'Categories.gaming'},
  photo_video: {id: 10100, icon: null, titleId: 'Categories.photo_video'},
  home_electronics: {
    id: 10101,
    icon: null,
    titleId: 'Categories.home_electronics'
  },
  furniture: {id: 10102, icon: null, titleId: 'Categories.furniture'},
  interior_decoration: {
    id: 10103,
    icon: null,
    titleId: 'Categories.interior_decoration'
  },
  kitchen_equipment: {
    id: 10104,
    icon: null,
    titleId: 'Categories.kitchen_equipment'
  },
  textiles: {id: 10105, icon: null, titleId: 'Categories.textiles'},
  lighting: {id: 10106, icon: null, titleId: 'Categories.lighting'},
  decor: {id: 10107, icon: null, titleId: 'Categories.decor'},

  physiotherapy: {id: 10108, icon: null, titleId: 'Categories.physiotherapy'},
  chiropractor: {id: 10109, icon: null, titleId: 'Categories.chiropractor'},
  massage: {id: 10110, icon: null, titleId: 'Categories.massage'},
  acupuncture: {id: 10111, icon: null, titleId: 'Categories.acupuncture'},
  naprapathy: {id: 10112, icon: null, titleId: 'Categories.naprapathy'},
  osteopathy: {id: 10113, icon: null, titleId: 'Categories.osteopathy'},
  hair_salon: {id: 10114, icon: null, titleId: 'Categories.hair_salon'},
  skin_care: {id: 10115, icon: null, titleId: 'Categories.skin_care'},
  nail_care: {id: 10116, icon: null, titleId: 'Categories.nail_care'},
  spa_treatments: {id: 10117, icon: null, titleId: 'Categories.spa_treatments'},
  makeup_cosmetics: {
    id: 10118,
    icon: null,
    titleId: 'Categories.makeup_cosmetics'
  },
  waxing_hair_removal: {
    id: 10119,
    icon: null,
    titleId: 'Categories.waxing_hair_removal'
  },
  pharmacy: {id: 10120, icon: null, titleId: 'Categories.pharmacy'},
  health_food: {id: 10121, icon: null, titleId: 'Categories.health_food'},
  sports_supplements: {
    id: 10122,
    icon: null,
    titleId: 'Categories.sports_supplements'
  },
  natural_medicine: {
    id: 10123,
    icon: null,
    titleId: 'Categories.natural_medicine'
  },
  medical_equipment: {
    id: 10124,
    icon: null,
    titleId: 'Categories.medical_equipment'
  },
  vision_correction: {
    id: 10125,
    icon: null,
    titleId: 'Categories.vision_correction'
  },

  daily_banking: {id: 10126, icon: null, titleId: 'Categories.daily_banking'},
  current_account: {
    id: 10127,
    icon: null,
    titleId: 'Categories.current_account'
  },
  savings_account: {
    id: 10128,
    icon: null,
    titleId: 'Categories.savings_account'
  },
  debit_credit_cards: {
    id: 10129,
    icon: null,
    titleId: 'Categories.debit_credit_cards'
  },
  mortgage: {id: 10130, icon: null, titleId: 'Categories.mortgage'},
  car_loan: {id: 10131, icon: null, titleId: 'Categories.car_loan'},
  consumer_loan: {id: 10132, icon: null, titleId: 'Categories.consumer_loan'},
  credit_loan: {id: 10133, icon: null, titleId: 'Categories.credit_loan'},
  saving_investment: {
    id: 10134,
    icon: null,
    titleId: 'Categories.saving_investment'
  },

  personal_insurance: {
    id: 10135,
    icon: null,
    titleId: 'Categories.personal_insurance'
  },
  life_insurance: {id: 10136, icon: null, titleId: 'Categories.life_insurance'},
  disability_insurance: {
    id: 10137,
    icon: null,
    titleId: 'Categories.disability_insurance'
  },
  child_insurance: {
    id: 10138,
    icon: null,
    titleId: 'Categories.child_insurance'
  },
  accident_insurance: {
    id: 10139,
    icon: null,
    titleId: 'Categories.accident_insurance'
  },
  critical_illness_insurance: {
    id: 10140,
    icon: null,
    titleId: 'Categories.critical_illness_insurance'
  },
  property_insurance: {
    id: 10141,
    icon: null,
    titleId: 'Categories.property_insurance'
  },
  home_insurance: {id: 10142, icon: null, titleId: 'Categories.home_insurance'},
  contents_insurance: {
    id: 10143,
    icon: null,
    titleId: 'Categories.contents_insurance'
  },
  cabin_insurance: {
    id: 10144,
    icon: null,
    titleId: 'Categories.cabin_insurance'
  },
  valuables_insurance: {
    id: 10145,
    icon: null,
    titleId: 'Categories.valuables_insurance'
  },
  moving_insurance: {
    id: 10146,
    icon: null,
    titleId: 'Categories.moving_insurance'
  },
  building_insurance: {
    id: 10147,
    icon: null,
    titleId: 'Categories.building_insurance'
  },
  fine_dining: {
    id: 23,
    titleId: 'Categories.fine_dining',
    icon: null
  },
  bus_services: {
    id: 24,
    titleId: 'Categories.bus_services',
    icon: null
  },
  train_services: {
    id: 25,
    titleId: 'Categories.train_services',
    icon: null
  },
  car_rentals: {
    id: 26,
    titleId: 'Categories.car_rentals',
    icon: null
  },
  car_maintenance: {
    id: 27,
    titleId: 'Categories.car_maintenance',
    icon: null
  },
  fashion_boutiques: {
    id: 28,
    titleId: 'Categories.fashion_boutiques',
    icon: null
  },
  sportswear: {
    id: 29,
    titleId: 'Categories.sportswear',
    icon: null
  },
  computer_stores: {
    id: 30,
    titleId: 'Categories.computer_stores',
    icon: null
  },
  mobile_devices: {
    id: 31,
    titleId: 'Categories.mobile_devices',
    icon: null
  },
  gyms: {
    id: 32,
    titleId: 'Categories.gyms',
    icon: null
  },
  yoga_studios: {
    id: 33,
    titleId: 'Categories.yoga_studios',
    icon: null
  },
  clinics: {
    id: 34,
    titleId: 'Categories.clinics',
    icon: null
  },
  pharmacies: {
    id: 35,
    titleId: 'Categories.pharmacies',
    icon: null
  },
  retail_banks: {
    id: 36,
    titleId: 'Categories.retail_banks',
    icon: null
  },
  online_banking: {
    id: 37,
    titleId: 'Categories.online_banking',
    icon: null
  },
  health_insurance: {
    id: 38,
    titleId: 'Categories.health_insurance',
    icon: null
  },
  car_insurance: {
    id: 42,
    titleId: 'Categories.car_insurance',
    icon: null
  },
  glasses: {
    id: 43,
    titleId: 'Categories.glasses',
    icon: null
  },
  eye_care_services: {
    id: 44,
    titleId: 'Categories.eye_care_services',
    icon: null
  },
  fuel_parking: {
    id: 10150,
    titleId: 'Categories.fuel_parking',
    icon: null
  },
  children_baby: {
    id: 10151,
    titleId: 'Categories.children_baby',
    icon: null
  },
  hobbies_leisure: {
    id: 10152,
    titleId: 'Categories.hobbies_leisure',
    icon: null
  },
  pet_store: {
    id: 10153,
    titleId: 'Categories.pet_store',
    icon: null
  },
  internet_broadband: {
    id: 10154,
    titleId: 'Categories.internet_broadband',
    icon: null
  },
  mobile_telephony: {
    id: 10155,
    titleId: 'Categories.mobile_telephony',
    icon: null
  },
  tv_streaming: {
    id: 10156,
    titleId: 'Categories.tv_streaming',
    icon: null
  },
  electricity_energy: {
    id: 10157,
    titleId: 'Categories.electricity_energy',
    icon: null
  },
  kebab_grill: {
    id: 10158,
    titleId: 'Categories.kebab_grill',
    icon: null
  },
  nightclubs: {
    id: 10159,
    titleId: 'Categories.nightclubs',
    icon: null
  },
  meal_delivery_services: {
    id: 10160,
    titleId: 'Categories.meal_delivery_services',
    icon: null
  },
  subway: {
    id: 10161,
    titleId: 'Categories.subway',
    icon: null
  },
  gas_stations: {
    id: 10162,
    titleId: 'Categories.gas_stations',
    icon: null
  },
  ev_charging_stations: {
    id: 10163,
    titleId: 'Categories.ev_charging_stations',
    icon: null
  },
  parking_lots: {
    id: 10164,
    titleId: 'Categories.parking_lots',
    icon: null
  },
  children_clothing: {
    id: 10165,
    titleId: 'Categories.children_clothing',
    icon: null
  },
  strollers: {
    id: 10166,
    titleId: 'Categories.strollers',
    icon: null
  },
  car_seats: {
    id: 10167,
    titleId: 'Categories.car_seats',
    icon: null
  },
  toys: {
    id: 10168,
    titleId: 'Categories.toys',
    icon: null
  },
  baby_toddler_equipment: {
    id: 10169,
    titleId: 'Categories.baby_toddler_equipment',
    icon: null
  },
  arts_crafts: {
    id: 10170,
    titleId: 'Categories.arts_crafts',
    icon: null
  },
  music_instruments: {
    id: 10171,
    titleId: 'Categories.music_instruments',
    icon: null
  },
  board_card_games: {
    id: 10172,
    titleId: 'Categories.board_card_games',
    icon: null
  },
  model_building: {
    id: 10173,
    titleId: 'Categories.model_building',
    icon: null
  },
  collectibles: {
    id: 10174,
    titleId: 'Categories.collectibles',
    icon: null
  },
  pet_food: {
    id: 10175,
    titleId: 'Categories.pet_food',
    icon: null
  },
  pet_supplies: {
    id: 10176,
    titleId: 'Categories.pet_supplies',
    icon: null
  },
  dog_grooming: {
    id: 10177,
    titleId: 'Categories.dog_grooming',
    icon: null
  },
  veterinary_services: {
    id: 10178,
    titleId: 'Categories.veterinary_services',
    icon: null
  },
  eyelashes_brows: {
    id: 10179,
    titleId: 'Categories.eyelashes_brows',
    icon: null
  },
  painter: {
    id: 10180,
    titleId: 'Categories.painter',
    icon: null
  },
  carpenter: {
    id: 10181,
    titleId: 'Categories.carpenter',
    icon: null
  },
  bricklayer: {
    id: 10182,
    titleId: 'Categories.bricklayer',
    icon: null
  },
  tiler: {
    id: 10183,
    titleId: 'Categories.tiler',
    icon: null
  },
  flooring: {
    id: 10184,
    titleId: 'Categories.flooring',
    icon: null
  },
  electrician: {
    id: 10185,
    titleId: 'Categories.electrician',
    icon: null
  },
  plumber: {
    id: 10186,
    titleId: 'Categories.plumber',
    icon: null
  },
  ventilation: {
    id: 10187,
    titleId: 'Categories.ventilation',
    icon: null
  },
  heat_pumps: {
    id: 10188,
    titleId: 'Categories.heat_pumps',
    icon: null
  },
  sanitation_systems: {
    id: 10189,
    titleId: 'Categories.sanitation_systems',
    icon: null
  },
  home_cleaning: {
    id: 10190,
    titleId: 'Categories.home_cleaning',
    icon: null
  },
  move_out_cleaning: {
    id: 10191,
    titleId: 'Categories.move_out_cleaning',
    icon: null
  },
  window_cleaning: {
    id: 10192,
    titleId: 'Categories.window_cleaning',
    icon: null
  },
  deep_cleaning: {
    id: 10193,
    titleId: 'Categories.deep_cleaning',
    icon: null
  },
  garden_work: {
    id: 10194,
    titleId: 'Categories.garden_work',
    icon: null
  },
  snow_removal: {
    id: 10195,
    titleId: 'Categories.snow_removal',
    icon: null
  },
  moving_companies: {
    id: 10196,
    titleId: 'Categories.moving_companies',
    icon: null
  },
  moving_transport: {
    id: 10197,
    titleId: 'Categories.moving_transport',
    icon: null
  },
  waste_management: {
    id: 10198,
    titleId: 'Categories.waste_management',
    icon: null
  },
  car_wash: {
    id: 10199,
    titleId: 'Categories.car_wash',
    icon: null
  },
  car_service: {
    id: 10200,
    titleId: 'Categories.car_service',
    icon: null
  },
  tires_rims: {
    id: 10201,
    titleId: 'Categories.tires_rims',
    icon: null
  },
  alarm_systems: {
    id: 10202,
    titleId: 'Categories.alarm_systems',
    icon: null
  },
  surveillance: {
    id: 10203,
    titleId: 'Categories.surveillance',
    icon: null
  },
  locksmith: {
    id: 10204,
    titleId: 'Categories.locksmith',
    icon: null
  },
  fire_protection: {
    id: 10205,
    titleId: 'Categories.fire_protection',
    icon: null
  },
  private_legal_assistance: {
    id: 10206,
    titleId: 'Categories.private_legal_assistance',
    icon: null
  },
  it_home_support: {
    id: 10207,
    titleId: 'Categories.it_home_support',
    icon: null
  },
  interior_consultant: {
    id: 10208,
    titleId: 'Categories.interior_consultant',
    icon: null
  },
  translation: {
    id: 10209,
    titleId: 'Categories.translation',
    icon: null
  },
  broadband_providers: {
    id: 10210,
    titleId: 'Categories.broadband_providers',
    icon: null
  },
  fiber_subscription: {
    id: 10211,
    titleId: 'Categories.fiber_subscription',
    icon: null
  },
  mobile_broadband: {
    id: 10212,
    titleId: 'Categories.mobile_broadband',
    icon: null
  },
  mobile_subscription: {
    id: 10213,
    titleId: 'Categories.mobile_subscription',
    icon: null
  },
  prepaid_cards: {
    id: 10214,
    titleId: 'Categories.prepaid_cards',
    icon: null
  },
  landline_telephony: {
    id: 10215,
    titleId: 'Categories.landline_telephony',
    icon: null
  },
  streaming_services: {
    id: 10216,
    titleId: 'Categories.streaming_services',
    icon: null
  },
  tv_packages: {
    id: 10217,
    titleId: 'Categories.tv_packages',
    icon: null
  },
  music_services: {
    id: 10218,
    titleId: 'Categories.music_services',
    icon: null
  },
  podcast_platforms: {
    id: 10219,
    titleId: 'Categories.podcast_platforms',
    icon: null
  },
  gaming_subscriptions: {
    id: 10220,
    titleId: 'Categories.gaming_subscriptions',
    icon: null
  },
  electricity_agreements: {
    id: 10221,
    titleId: 'Categories.electricity_agreements',
    icon: null
  },
  green_energy: {
    id: 10222,
    titleId: 'Categories.green_energy',
    icon: null
  },
  energy_monitoring_services: {
    id: 10223,
    titleId: 'Categories.energy_monitoring_services',
    icon: null
  },
  vehicle_insurance: {
    id: 10224,
    titleId: 'Categories.vehicle_insurance',
    icon: null
  },
  storage: {
    id: 10225,
    titleId: 'Categories.storage',
    icon: null
  }
};

export const benefitStatusTranslationKeyMap = {
  [benefitStatus.active]: 'BenefitStatus.active',
  [benefitStatus.inactive]: 'BenefitStatus.inactive',
  [benefitStatus.underReview]: 'BenefitStatus.underReview',
  [benefitStatus.expired]: 'BenefitStatus.expired',
  [benefitStatus.pending]: 'BenefitStatus.pending'
};

export const benefitStatusToggleKeyMap = {
  [benefitStatus.active]: true,
  [benefitStatus.inactive]: false,
  [benefitStatus.underReview]: undefined,
  [benefitStatus.expired]: undefined,
  [benefitStatus.pending]: undefined
};

export const merchantsSizesKeyMap = {
  local: 'SignUpPage.MerchantTypeInput.options.third.title',
  national: 'SignUpPage.MerchantTypeInput.options.first.title',
  regional: 'SignUpPage.MerchantTypeInput.options.second.title'
};

export const organisationTypesKeyMap = {
  national: 'SubscriptionsPage.OrgDetails.national',
  regional: 'SubscriptionsPage.OrgDetails.regional',
  local: 'SubscriptionsPage.OrgDetails.local'
};
